import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { EXPERIMENT_MEMBERS_AREA } from '../../constants/experiments';
import { setIsLoaded } from '../../actions/set-is-loaded';
import fetchSearch from '../../actions/fetch-search';
import { MIN_QUERY_LENGTH } from '../../actions/search';
import AppLoaded from '../../components/app-loaded';
import AnimatedLoader from '../../components/animated-loader';
import Page from '../../components/page';
import NoSearchResults from '../../components/no-search-results';
import DefaultDesktopLayout from '../../components/default-desktop-layout';
import SearchResultsList from '../search-results-list';
import MemberList from '../../components/member-list';
import { getIsSearchLoading } from '../../selectors/is-loading-selectors';
import { getIsSearchLoaded } from '../../selectors/is-loaded-selectors';
import withExperiment from '../../hoc/with-experiment';

const TYPES = ['posts', 'members'];
export const getResultCounts = (search, excludedType) => {
  return _(TYPES)
    .filter(type => type !== excludedType)
    .map(type => ({
      type,
      count: search && search[type].length,
    }))
    .filter(type => type.count)
    .value();
};

const createResultsPage = (type, alternativeType) => {
  const ResultsPage = ({ search, location, isLoading, isMembersAreaEnabled }) => {
    const hasResults = Boolean(_.get(search[type], 'length', 0));
    const resultCounts = isMembersAreaEnabled ? [] : getResultCounts(search, type);

    return (
      <Page noSpacing={!hasResults}>
        <DefaultDesktopLayout>
          <AnimatedLoader isLoading={isLoading} isAnimated={true}>
            {hasResults ?
              renderResults(type, search, location.query.query) :
              <NoSearchResults
                type={type}
                alternativeType={alternativeType}
                query={location.query.query}
                resultCounts={resultCounts}
              />}
          </AnimatedLoader>
          {!isLoading && <AppLoaded/>}
        </DefaultDesktopLayout>
      </Page>
    );
  };

  ResultsPage.fetchData = ({ store, query: { query } }) => {
    if (query && query.length >= MIN_QUERY_LENGTH) {
      return store.dispatch(fetchSearch(query));
    }
  };

  ResultsPage.propTypes = {
    search: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    setIsLoaded: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    isMembersAreaEnabled: PropTypes.bool,
  };

  const mapStateToProps = state => ({
    search: state.search,
    isLoading: getIsSearchLoading(state),
    isLoaded: getIsSearchLoaded(state),
  });

  const mapDispatchToProps = {
    setIsLoaded,
  };

  return _.flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withExperiment({
      isMembersAreaEnabled: EXPERIMENT_MEMBERS_AREA,
    }),
  )(ResultsPage);
};

function renderResults(type, search, query) {
  const results = search[type];

  switch (type) {
    case 'posts':
      return <SearchResultsList posts={results} query={query}/>;
    case 'members':
      return <MemberList members={results}/>;
    default:
      return <div/>;
  }
}

export default createResultsPage;



// WEBPACK FOOTER //
// ./app/containers/results-page/results-page.js